import { Component, OnInit, EventEmitter, Output, ViewChild, ViewContainerRef, Input } from '@angular/core';
import { EditorComponent } from "@progress/kendo-angular-editor";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ToolbarItem } from '../../../shared/interfaces/tool-bar-item.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { INotificationService } from '../../../shared/services/inotification.service';
import { FeedbackMessageService } from '../../../shared/services/feedback-message.service';
import { DetailService } from '../../../core/services/detail.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BaseComponent } from '../../../core/models/base-component.model';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { SVGIcon, arrowUpIcon, arrowDownIcon, trashIcon, copyIcon, clipboardIcon } from '@progress/kendo-svg-icons';
import { Item } from '../../../shared/interfaces/entities/item.interface';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { faPlus, faSearch, faSave, faArrowsSplitUpAndLeft } from '@fortawesome/free-solid-svg-icons';
import { throwError } from 'rxjs';
import { CollectionSelect } from '../../../shared/ui/select-controls/collection-select.model';
import { DialogComponent } from '../../../shared/components/dialog/dialog.component';
import { ViewControl } from '../../../shared/ui/controls/view-control.model';
import { TextControl } from '../../../shared/ui/controls/text-control.model';
import { ViewRowControl } from '../../../shared/ui/controls/view-row-control.model';
import { UiGroupControl } from '../../../shared/ui/controls/ui-group-control.model';
import { EditorControl } from '../../../shared/ui/controls/editor-control.model';
import { OrganizationSelect } from '../../../shared/ui/select-controls/organizations-select.model';
import { ItemService } from '../services/item-service';
import { UploadControl } from '../../../shared/ui/controls/upload-control.model';
import { ReadOnlyProperty, VisibleProperty } from '../../../shared/ui/control-options/control-option.interface';
import { CollectionFilter } from '../../../shared/interfaces/select-filters/collection-filter.interface';
import { ToggleControl } from '../../../shared/ui/controls/toggle-control.model';
import { Permission } from '@core/literals/permission.literal';
import { WindowService, WindowSettings, WindowRef } from '@progress/kendo-angular-dialog';
import { ItemSplitComponent } from '../item-split/item-split.component';
import { GridControl } from '../../../shared/ui/controls/grid-control.model';
import { UiColumn } from '../../../shared/ui/ui-column';
import { TabOptions } from '../../../shared/interfaces/tab-option.interface';
import { CellClickEvent, GridComponent, PagerSettings, RowArgs, SelectableSettings } from '@progress/kendo-angular-grid';
import { GridDataBindingDirective } from '../../../shared/directives/grid-data-binding.directive';
import { State, process } from '@progress/kendo-data-query';
import { ContextMenuItem } from '../../../shared/interfaces/contex-menu-item.interface';
import { ContextMenuComponent, ContextMenuSelectEvent } from '@progress/kendo-angular-menu';
import { faClipboard, faCopy } from '@fortawesome/free-solid-svg-icons';
import { Clipboard } from '@angular/cdk/clipboard';
import { AddOnOptionsSelect } from '../../../shared/ui/select-controls/add-on-options-select.model';

@Component({
    selector: 'app-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.css'],
    standalone: false
})

export class ItemComponent extends BaseComponent implements OnInit {

  @ViewChild("upload") public dialog: DialogComponent;
  @Output() @ViewChild("editor") public editor: EditorComponent;

  @ViewChild(GridDataBindingDirective) db: GridDataBindingDirective;
  @ViewChild('grid') public orderGrid: GridComponent;
  @ViewChild("gridMenu") public gridContextMenu: ContextMenuComponent;
  contextMenuItems: ContextMenuItem[] = [];

  @ViewChild('orderSection', { read: ViewContainerRef, static: false }) public orderSection: ViewContainerRef;

  public state: State = { skip: 0, take: 100 };

  id: string;

  @Input() entity: Item;
  @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();

  submitted: boolean = false;
  toolbarItems: ToolbarItem[] = [];
  title: string;
  inventoryCount: string;
  draftOrActive: string;
  organizationId: number;

  name: string;
  formName: string;
  apiController: string;
  views: ViewControl[] = [];
  keyFieldName: string;
  breadCrumbPropertyNames: string[] = [];
  updateItemPermission: boolean;
  isAdmin: boolean;
  itemUniqnumList: any[] = [];
  data: any[] = [];

  gridState: State = { sort: [], skip: 0, take: 1000 }

  public pageSize: number = 25;
  pagerSettings: PagerSettings;

  selectedRow?: Item;
  public lastSelectedColumnName: number;
  public lastSelectedItem: any;
  public mySelection: number[] = [];
  public lastSelectedRowIndex: number;
  public lastPointerEvent: PointerEvent;
  private rowIndex: any;
  private rowId: string;
  private contextItem: any;
  public showCommandRow: boolean = false;

  public selectableSettings: SelectableSettings = { mode: "multiple", drag: true };

  public itemAddonOptions: AddOnOptionsSelect;

  constructor(private activatedRouter: ActivatedRoute,
    private router: Router,
    private detailService: DetailService<any>,
    private auth: AuthenticationService,
    private service: ItemService,
    private windowService: WindowService,
    private clipboard: Clipboard,
    private notificationService: INotificationService) {
    super();

    this.name = "Item";
    this.apiController = "Item";
    this.keyFieldName = "id";
    this.breadCrumbPropertyNames = ["title"];
    this.updateItemPermission = this.auth.canPerformAction(Permission.UpdateItems);

    this.activatedRouter.params.subscribe(params => this.id = params['id']);

    this.initializeUiControls();
  }

  ngOnInit(): void {

    this.pagerSettings = {
      previousNext: true,
      position: "bottom",
      info: true,
      type: "input",
      pageSizes: [25, 50, 100, 500]
    };

    var copyText: ContextMenuItem = {
      title: "Copy Text",
      iconClass: clipboardIcon,
      action: this.copyText.bind(this),
    }

    var copyUniqnums: ContextMenuItem = {
      title: "Copy Uniqnums",
      iconClass: clipboardIcon,
      action: () => { this.copyUniqnums(); }
    }

    this.contextMenuItems.push(copyText, copyUniqnums); 


  }

  addToCart() {
    this.router.navigate(['/Item/AddToCart/' + this.id]);
  }

  splitItem() {
    //Open the modal

    var event = window.event;
    event?.preventDefault();

    let x = window.scrollX;
    let y = window.scrollY;

    window.onscroll = () => {
      window.scrollTo(x, y);
    }

    setTimeout(() => {
      window.onscroll = () => { };
    });

    var options: WindowSettings = {
      title: 'Item Split',
      width: 600,
      height: 500,
      content: ItemSplitComponent,
      draggable: true,
      resizable: true,
      top: 200
    };

    const win = this.windowService.open(options);
  }

  public open() {
    this.dialog.open();
  }

  onCellClicked(e: CellClickEvent): void {
    this.selectedRow = e.dataItem;

    // Handle Row Selection
    // We need to do custom row selection logic because selecting a row by right-click is not supported.
    // This will handle single row selection, and multi selection using the shift key or ctrl key.
    if (e.rowIndex != undefined) {
      var firstRowIndex = this.lastSelectedRowIndex;
      var lastRowIndex = e.rowIndex;

      var rightClick = window.event !== undefined && (window.event as PointerEvent).which == 3;
      var multiSelectWithCtrl = this.lastPointerEvent != null && this.lastPointerEvent.ctrlKey;
      var multiSelectWithShift = this.lastPointerEvent != null && this.lastPointerEvent.shiftKey;

      if (this.lastPointerEvent == undefined && window.event !== undefined && window.event instanceof PointerEvent) {
        this.lastPointerEvent = window.event;
      }

      if (rightClick) {
        if (!this.mySelection.includes(lastRowIndex)) {
          this.mySelection.push(lastRowIndex);
        }
      } else if (multiSelectWithShift) {
        var selectedIndexes = this.range(firstRowIndex, lastRowIndex);
        this.mySelection = [];
        Array.prototype.push.apply(this.mySelection, selectedIndexes);
      } else if (multiSelectWithCtrl) {
        this.mySelection.push(lastRowIndex);
      } else {
        this.mySelection = [];
        this.mySelection.push(lastRowIndex);
      }
    }

    this.lastSelectedRowIndex = e.rowIndex;
    this.lastSelectedColumnName = e.column.field;
    this.lastSelectedItem = e.dataItem;

    if (e.type == "contextmenu") {
      e.originalEvent.preventDefault();

      this.gridContextMenu.show({
        left: e.originalEvent.pageX,
        top: e.originalEvent.pageY
      });
    }
  }

  copyUniqnums() {
    var itemCount = this.itemUniqnumList.map(e => e.uniqnum).join(",");
    this.clipboard.copy(itemCount);
  }


  private range(start: number, end: number): number[] {
    if (end > start) {
      return Array
        .apply(null, Array((end - start) + 1))
        .map(function (_, n) { return n + start; });
    } else {
      return Array
        .apply(null, Array((start - end) + 1))
        .map(function (_, n) { return n + end; });
    }
  }


  onContextMenuSelect(e: ContextMenuSelectEvent) {
    if (e.item && e.item.data.action) {
      e.item.data.action(e.item.data.params);
    }
  }

  copyText(): void {
    var value: string = "";
    if (this.lastSelectedItem && this.lastSelectedColumnName) {
      value = this.lastSelectedItem[this.lastSelectedColumnName];
    }

    this.clipboard.copy(value);
  }

  entityLoaded(): void {
    if (this.entity) {
      var session = this.auth.getSession();
      this.organizationId = this.auth.getOrganizationId();
      this.isAdmin = this.auth.isAdmin();

      if (this.isAdmin) {
        this.service.getItemUnqinumList(this.id).subscribe(data => {
          this.itemUniqnumList = data;
        });
      }

      var canAddItemToCart: boolean = (this.entity.isDraft == false && this.entity.isActive == true);
      var canSplitItem: boolean = (this.entity.isDraft == true && this.entity.isActive == true && this.auth.canPerformAction(Permission.SplitItems)); //Change this to split permission

      if (this.entity.isDraft == true) {
        this.draftOrActive = "Draft";
      } else {
        this.draftOrActive = "Active";
      }

      //check if this record matches the current organizationId
      if (this.entity.organizationId != session?.organizationId) { 
        throwError(() => new Error('You are not allowed to view this due to organization'));

        this.router.navigate(['']);
        this.notificationService.show({ title: "Error!", type: "error", description: "You are not allowed to view this due to organization" });
      }

      var countriesUserHasAccessTo = session?.countryList.map(obj => obj.id);
      //check if this record matches the user's country/countries
      if (!countriesUserHasAccessTo?.includes(this.entity.countryId)) {
        throwError(() => new Error('You are not allowed to view this due to country'));

        this.router.navigate(['']);
        this.notificationService.show({ title: "Error!", type: "error", description: "You are not allowed to view this due to country! Please reach out to your administrator." });
      }

      //Item must not be a draft and must be currently active
      if (canAddItemToCart) {
        var item: ToolbarItem = {
          text: 'Add to Cart',
          icon: faPlus,
          cssClass: 'success',
          hasMultiple: false,
          action: () => { this.addToCart(); }
        };

        var items = this.toolbarItems;
        this.toolbarItems = [];
        for (var i = 0; i < items.length; i++) {
          this.toolbarItems.push(items[i]);
        }
        this.toolbarItems.push(item)
      }

      //if we don't have any componets then remove the detail card
      if (this.entity.componentsList.length == 0) {
        var removeComponents = this.views.findIndex(x => x.title == "Components");
        this.views.splice(removeComponents, 1);
      }

      if (canSplitItem) {
        var splitItem: ToolbarItem = {
          text: 'Split Item',
          icon: faArrowsSplitUpAndLeft,
          cssClass: 'purpleBg',
          hasMultiple: false,
          action: () => { this.splitItem(); }
        };
      }
    }
  }

  preSave(formControls: { [k: string]: FormControl }): void {
    var organizationId = this.auth.getOrganizationId();
    formControls['organizationId'] = new FormControl(organizationId);
  }

  public isRowSelected = (e: RowArgs): boolean =>
    this.mySelection.indexOf(e.index) >= 0;

  public onCellClick(e: any): void {
    if (e.type === "contextmenu") {
      const originalEvent = e.originalEvent;
      originalEvent.preventDefault();

      this.orderGrid.closeRow(this.rowIndex);

      this.rowIndex = e.rowIndex;
      this.rowId = e.dataItem.Id;
      this.contextItem = e.dataItem;
      this.showCommandRow = false;

      this.gridContextMenu.show({
        left: originalEvent.pageX,
        top: originalEvent.pageY,
      });
    }
  }


  initializeUiControls() {
    var isReadonly = this.auth.canPerformAction(Permission.UpdateItems) ? false : true;

    const skuCard = new ViewControl("Inventory");
    const collectionCard = new ViewControl("Collection");
    const itemDetailCard = new ViewControl("Details");
    const imageUploadDetailCard = new ViewControl("Media");
    const itemComponentDetailCard = new ViewControl("Components");

    const skuDetails = new UiGroupControl("", "SKU Details");
    const collectionDetails = new UiGroupControl("", "Colllection Details");
    const itemDetails = new UiGroupControl("", "Item Details");
    const imageUploadDetails = new UiGroupControl("", "Image Details");
    const itemComponentDetails = new UiGroupControl("", "Component Details");

    const sku = new TextControl("sku", "SKU", "");
    sku.addOption(new ReadOnlyProperty());

    const availableCount = new TextControl("availableCount", "Available Items", "");
    availableCount.addOption(new VisibleProperty((): boolean => { return this.auth.isAdmin() }));
    availableCount.addOption(new ReadOnlyProperty());

    const reservedCount = new TextControl("reservedCount", "Reserved Items", "");
    reservedCount.addOption(new VisibleProperty((): boolean => { return this.auth.isAdmin() }));
    reservedCount.addOption(new ReadOnlyProperty());

    const soldCount = new TextControl("soldCount", "Sold Items", "");
    soldCount.addOption(new VisibleProperty((): boolean => { return this.auth.isAdmin() }));
    soldCount.addOption(new ReadOnlyProperty());

    var collectionFilters: CollectionFilter = {
      organizationId: this.auth.getOrganizationId()
    };

    const collection = new CollectionSelect("itemCollections", "Collection", new Array<any>);
    collection.filters = collectionFilters;

    if (isReadonly) {
      collection.addOption(new ReadOnlyProperty());
    }

    const isDraft = new ToggleControl("isDraft", "Is Draft?", null);
    if (isReadonly) {
      isDraft.addOption(new VisibleProperty((): boolean => { return false; }));
    }

    const hideUniqnum = new ToggleControl("hideUniqnum", "Hide Uniqnum?", null);
    if (isReadonly && this.isAdmin) {
      hideUniqnum.addOption(new VisibleProperty((): boolean => { return false; }));
    }

    //This is for when the user goes to add the item to the cart, they would have options to add addons
    this.itemAddonOptions = new AddOnOptionsSelect("itemAddonOptions", "Add on Options", new Array<any>);

    const title = new TextControl("title", "Title", "");
    title.addOption(new ReadOnlyProperty());

    const partNumber = new TextControl("partNumber", "Part Number", "");
    partNumber.addOption(new ReadOnlyProperty());

    var desc = "description";

    if (isReadonly) {
      desc = "generalNotes";
    }

    const description = new EditorControl(desc, "Description", "", false);
    description.addOption(new ReadOnlyProperty());

    const notes = new EditorControl("notes", "Notes", "", false);
    if (isReadonly) {
      notes.addOption(new VisibleProperty((): boolean => { return false; }));
    } 
    const imageUpload = new UploadControl("editorImages", "", new Array<string>);


    var collectionOrganizationColumns: UiColumn[] = [
      new UiColumn("component", "Component", 90),
      new UiColumn("componentCnt", "Qty", 10)
    ];

    var collectionOrganizationOptions: TabOptions = {
      name: "componentsList",
      label: "",
      columns: collectionOrganizationColumns,
      apiController: "Item",
      isDataPreloaded: true,
      showDeleteBtn: false,
      showEditBtn: false
    };

    const components = new GridControl(collectionOrganizationOptions);

    var skuRow = new ViewRowControl();
    skuRow.controls.push(sku, availableCount, reservedCount, soldCount);

    var collectionRow = new ViewRowControl();
    collectionRow.controls.push(collection, this.itemAddonOptions);


    var titleRow = new ViewRowControl();
    titleRow.controls.push(isDraft, hideUniqnum, title, partNumber, description, notes);

    var imageUploadRow = new ViewRowControl();
    imageUploadRow.controls.push(imageUpload);

    var componentsRow = new ViewRowControl();
    componentsRow.controls.push(components);

    skuDetails.rows.push(skuRow);
    skuCard.controls.push(skuDetails);

    collectionDetails.rows.push(collectionRow);
    collectionCard.controls.push(collectionDetails);

    itemDetails.rows.push(titleRow);
    itemDetailCard.controls.push(itemDetails);

    itemComponentDetails.rows.push(componentsRow);
    itemComponentDetailCard.controls.push(itemComponentDetails);

    imageUploadDetails.rows.push(imageUploadRow);
    imageUploadDetailCard.controls.push(imageUploadDetails);

    //General users don't need all that info: just the components, media, and details
    if (this.auth.isAdmin()) {
      this.views.push(collectionCard, skuCard, itemComponentDetailCard, imageUploadDetailCard, itemDetailCard);
    } else {
      this.views.push(itemComponentDetailCard, imageUploadDetailCard, itemDetailCard);
    }
  }
}







